// Maximum number of SSH access keys a user may hold at once (slots 0 and 1).
export const MAX_KEYS = 2;

// Slots an access key can occupy, in preference order for the next-available lookup.
export const KEY_SLOTS = [0, 1];

// Slot 0 renders as the "Blue Key", every other slot as the "Green Key".
export const BLUE_KEY_SLOT = 0;

// DownloadKeysModal start-time modes.
export const START_MODE = {
  NOW: 'now',
  SCHEDULE: 'schedule',
};

// Minute granularity offered by the schedule time picker.
export const MINUTE_INTERVAL = 15;

// A key may be scheduled to start at most this many hours in the future.
export const MAX_SCHEDULE_HOURS = 24;
